import { render } from "./editBaseInformation.vue?vue&type=template&id=c797859a&ts=true"
import script from "./editBaseInformation.vue?vue&type=script&lang=ts"
export * from "./editBaseInformation.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__